"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  ExclusiveBenefits = _require.ExclusiveBenefits;
const formatExclusiveBenefits = (properties, options = {}) => {
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$porintId = properties.porintId,
    porintId = _properties$porintId === void 0 ? '' : _properties$porintId,
    _properties$leftObjec = properties.leftObject,
    leftObject = _properties$leftObjec === void 0 ? {} : _properties$leftObjec,
    _properties$rightList = properties.rightList,
    rightList = _properties$rightList === void 0 ? [] : _properties$rightList;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _leftObject$btnTxt = leftObject.btnTxt,
    btnTxt = _leftObject$btnTxt === void 0 ? '' : _leftObject$btnTxt,
    _leftObject$href = leftObject.href,
    hrefBase = _leftObject$href === void 0 ? '' : _leftObject$href,
    _leftObject$commodity = leftObject.commodityObject,
    commodityObject = _leftObject$commodity === void 0 ? '{}' : _leftObject$commodity,
    richTextContent = leftObject.modalConfiguration.richTextContent;
  const href = formatUrlString(hrefBase);
  const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
  const commodityItem = _objectSpread(_objectSpread({}, resultCommodityObject), {}, {
    href
  });
  const leftObjectHandled = _objectSpread(_objectSpread({}, leftObject), {}, {
    onCallback() {
      window.asyncReceiveCommodity(commodityItem);
    },
    extendProps: {
      'report-event': 'click_exclusive_benefits_left_apply_button',
      'report-ext1': btnTxt
    },
    modalConfiguration: _objectSpread(_objectSpread({}, (leftObject === null || leftObject === void 0 ? void 0 : leftObject.modalConfiguration) || {}), {}, {
      richTextContent: formatUrlInText(richTextContent) // 富文本
    })
  });
  const resultRightList = rightList.map((item, index) => {
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$desc = item.desc,
      desc = _item$desc === void 0 ? '' : _item$desc,
      _item$txt = item.txt,
      txt = _item$txt === void 0 ? '' : _item$txt,
      _item$href = item.href,
      hrefBase = _item$href === void 0 ? '' : _item$href,
      _item$buttonConfig = item.buttonConfig,
      buttonConfig = _item$buttonConfig === void 0 ? {} : _item$buttonConfig;
    const _buttonConfig$text = buttonConfig.text,
      btnTxt = _buttonConfig$text === void 0 ? '' : _buttonConfig$text,
      _buttonConfig$href = buttonConfig.href,
      btnHrefBase = _buttonConfig$href === void 0 ? '' : _buttonConfig$href;
    const href = formatUrlString(hrefBase);
    const btnHref = formatUrlString(btnHrefBase);
    const resultBtnConfig = _objectSpread(_objectSpread({}, buttonConfig), {}, {
      href: btnHref,
      colType: 'text',
      sizeType: 'large',
      alignType: 'center',
      btnExtendProps: {
        'report-event': 'click_exclusiveBenefits_right_button',
        'report-ext1': index,
        'report-ext2': btnTxt,
        'report-ext3': btnHref
      }
    });
    resultBtnConfig.onCallback = function () {
      window.location.href = btnHref;
    };
    return {
      title,
      desc: formatUrlInText(desc),
      txt,
      href,
      buttonConfig: resultBtnConfig,
      moreExtendProps: {
        'report-event': 'click_exclusiveBenefits_right_more_button',
        'report-ext1': index,
        'report-ext2': txt,
        'report-ext3': href
      }
    };
  });
  return {
    modTitle,
    color,
    porintId,
    leftObject: leftObjectHandled,
    rightList: resultRightList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatExclusiveBenef = formatExclusiveBenefits(data, {
        domains
      }),
      modTitle = _formatExclusiveBenef.modTitle,
      color = _formatExclusiveBenef.color,
      porintId = _formatExclusiveBenef.porintId,
      leftObject = _formatExclusiveBenef.leftObject,
      rightList = _formatExclusiveBenef.rightList;
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    const _leftObject$leftTitle = leftObject.leftTitle,
      leftTitle = _leftObject$leftTitle === void 0 ? '' : _leftObject$leftTitle,
      _leftObject$leftDesc = leftObject.leftDesc,
      leftDesc = _leftObject$leftDesc === void 0 ? '' : _leftObject$leftDesc,
      _leftObject$leftMore = leftObject.leftMore,
      leftMore = _leftObject$leftMore === void 0 ? '' : _leftObject$leftMore,
      _leftObject$modalConf = leftObject.modalConfiguration,
      modalConfiguration = _leftObject$modalConf === void 0 ? {} : _leftObject$modalConf,
      _leftObject$lefttxtLi = leftObject.lefttxtList,
      lefttxtList = _leftObject$lefttxtLi === void 0 ? [] : _leftObject$lefttxtLi,
      _leftObject$leftNum = leftObject.leftNum,
      leftNum = _leftObject$leftNum === void 0 ? '' : _leftObject$leftNum,
      _leftObject$btnTxt2 = leftObject.btnTxt,
      btnTxt = _leftObject$btnTxt2 === void 0 ? '' : _leftObject$btnTxt2,
      onCallback = leftObject.onCallback,
      extendProps = leftObject.extendProps;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_exclusiveBenefits', componentKey, modTitle])), /*#__PURE__*/React.createElement(ExclusiveBenefits, {
      style: bgStyle,
      title: modTitle,
      leftTitle: leftTitle,
      leftDesc: leftDesc,
      leftMore: leftMore,
      modalConfiguration: modalConfiguration,
      lefttxtList: lefttxtList,
      leftNum: leftNum,
      btnTxt: btnTxt,
      onCallback: onCallback,
      rightList: rightList,
      extendProps: extendProps
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}